import { __decorate, __param, __metadata } from 'tslib';
import { StopAction } from '../../decorators/param/stop-action.js';
import { ControllerRegistry } from '../../registries/controller-registry.js';
import { ActionPointInfo } from '../../decorators/param/action-point-info.js';
import { Middleware } from '../../decorators/class/middleware.js';
import { TrackControllerService } from '../../services/controller/track-controller-service.js';
import { AdapterMatchService } from '../../controllers/adapter/adapter-match-service.js';
import { Editor } from '../../decorators/param/editor.js';

/**
 * 用于管理EditorProvider的服务，可通过此服务查看当前editor焦点下，provider是否可用。
 *
 * @internal
 */
let AdapterMatchMiddleware = class AdapterMatchMiddleware {
    constructor(trackControllerService, adapterMatchService) {
        this.trackControllerService = trackControllerService;
        this.adapterMatchService = adapterMatchService;
    }
    // shouldDisable
    use(info, editor, stop) {
        const target = this.trackControllerService.getConfigController(info.from + info.name);
        const provider = target ? ControllerRegistry.get(target) : undefined;
        if (!this.adapterMatchService.isAvailable(provider, editor)) {
            stop();
            return true;
        }
        return false;
    }
};
__decorate([
    __param(0, ActionPointInfo()),
    __param(1, Editor()),
    __param(2, StopAction()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object, Function]),
    __metadata("design:returntype", void 0)
], AdapterMatchMiddleware.prototype, "use", null);
AdapterMatchMiddleware = __decorate([
    Middleware(),
    __metadata("design:paramtypes", [TrackControllerService,
        AdapterMatchService])
], AdapterMatchMiddleware);

export { AdapterMatchMiddleware };
//# sourceMappingURL=adapter-match.middleware.js.map
